<template>
    <CodiceFeanorView tool-module="stegoAnalyze" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
